import { jwtDecode } from 'jwt-decode'
import type { SparkUser } from 'types'

export const USER_LOGIN_STATE_KEY = 'userLoginState'

export const getJwtExpiryMs = (token?: string): number | null => {
  if (!token) return null

  try {
    const { exp } = jwtDecode(token)
    if (typeof exp !== 'number' || !Number.isFinite(exp)) {
      return null
    }
    return exp * 1000
  } catch {
    return null
  }
}

export const readCachedUser = (): SparkUser | null => {
  try {
    const cached = localStorage.getItem(USER_LOGIN_STATE_KEY)
    return cached ? (JSON.parse(cached) as SparkUser) : null
  } catch {
    return null
  }
}

export const isCachedUserUsable = (
  user: SparkUser | null,
  accessToken: string | undefined,
  lanId: string | undefined,
  now = Date.now(),
): user is SparkUser => {
  if (!user?.userProfileId || !user.userProfileToken || !accessToken) {
    return false
  }

  const expiryMs = getJwtExpiryMs(user.userProfileToken)
  if (!expiryMs || expiryMs <= now) return false

  if (user.accessToken !== accessToken) return false

  const cachedLanId = user.userId
  return Boolean(
    lanId &&
    typeof cachedLanId === 'string' &&
    cachedLanId.toLowerCase() === lanId.toLowerCase(),
  )
}

export const saveCachedUser = (user: SparkUser) => {
  localStorage.setItem(USER_LOGIN_STATE_KEY, JSON.stringify(user))
}
